export enum Submit {
  notSubmitted,
  submitting,
  submitted,
}
